<template>
    <div class="detail main-top-border">
        <div class="main-bg">
            <div class="main-wrap">
                <el-breadcrumb separator-class="el-icon-arrow-right" class="crumb">
                    <el-breadcrumb-item :to="{ path: '/' }">买兰花</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/goods' }">选择分类</el-breadcrumb-item>
                    <el-breadcrumb-item>{{oneType.typeName}}{{twoType.typeName}}{{goods.leiBie}}{{goods.daiHua}}</el-breadcrumb-item>
                    <el-breadcrumb-item>商品详情</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="main-wrap">
            <div class="goods-cont">
                <div class="fl goods-img">

                    <div class="big-img" v-if="goodsType!==2">
                        <video
                                v-if="isShowVideo"
                                class="big-img"
                                :src="$common.videoPath(goods.goodsVideo)"
                                :preload="$common.imgPath(goods.goodsLog)"
                                controls
                        >
                        </video>
                        <div v-if="!isShowVideo&&currentImg.length>0" class="big-img">
                            <pic-zoom :url="$common.imgPath(currentImg,'350x350')" :scale="3"></pic-zoom>
                        </div>
                        <!--<el-image v-if="!isShowVideo" :src="$common.imgPath(currentImg)" :alt="currentImg" class="big-img" lazy></el-image>-->
                    </div>
                    <div class="thumb"  v-if="goodsType!==2">
                        <div class="fl btns el-icon-arrow-left" @click="prevThumb()"></div>
                        <div class="thumb-cont">
                            <ul class="thumb-list" :style="'width:'+(goodsImgList.length+2)*62+'px;margin-left:-'+currentIndex*52+'px'">
                                <li ref="thumb"
                                    :class="isShowVideo?'current':''"
                                    v-if="goods.goodsVideo"
                                    @click="isShowVideo=true"
                                >
                                    <div class="video-option">
                                        <el-image :src="$common.imgPath(goods.goodsLog)" class="thumb-img" lazy></el-image>
                                        <span class="btn-play"><i class="el-icon-caret-right"></i></span>
                                    </div>
                                </li>
                                <li
                                        ref="thumb"
                                        v-for="(item,index) in goodsImgList"
                                        :class="currentIndex==index&&!isShowVideo?'current':''"
                                        @click="currentThumb(index,item)"
                                        :key="index"
                                >
                                    <el-image :src='$common.imgPath(item)'  :alt="item" class="img-item"></el-image>
                                </li>
                            </ul>
                        </div>
                        <div class="fr btns el-icon-arrow-right" @click="nextThumb()"></div>
                    </div>
                    <video
                            v-if="goodsType==2"
                            class="video-main"
                            :src="$common.videoPath(goods.goodsVideo)"
                            :preload="$common.imgPath(goods.goodsLog)"
                            controls
                    >

                    </video>
                    <div class="shop" v-if="goodsType!==1">
                        <div class="shop-name">
                            {{shop.shopName}}
                            <el-tag class="shop-tag" color="#15B249" size="mini" effect="dark" v-if="shop.isCelebrity==1">名人</el-tag>
                        </div>
                        <ul class="num-list">
                            <li>
                                <p><span class="num">{{nowGoodsNum}}</span>件</p>
                                <span class="tit">全部拍品</span>
                            </li>
                            <li>
                                <p><span class="num">{{shop.collectNum}}</span>人</p>
                                <span class="tit">粉丝数</span>
                            </li>
                            <li>
                                <p><span class="num">{{shop.starNum}}</span></p>
                                <span class="tit">评分</span>
                            </li>
                        </ul>
                        <div class="btn-shop">
                            <el-button  class="btn fl" @click="$router.push({path:`/shop/detail/${shop.shopId}`})"><i class="el-icon-s-home"></i>进店逛逛</el-button>
                            <el-button class="btn fl" @click="goChat(shop.userId)"><i class="el-icon-chat-line-round"></i>联系客服</el-button>
                            <!--<el-button  class="btn fl" @click="goChat(shop.userId)"><i class="el-icon-s-home"></i>联系客服</el-button>-->
                            <el-button  class="btn fr" @click="setShopFollow()"><span class="icon-collect" :class="isCollect?'collect-yellow-color':'collect-grey-color'"></span><span v-text="isCollect?'取消关注':'关注店铺'"></span></el-button>
                        </div>

                    </div>
                </div>
                <div class="fl goods-info">
                    <p class="info-desc" :class="{'pb20':goodsType==2}">{{goods.goodsName}}</p>
                    <p class="tag" v-if="goodsType!==2" v-text="oneType.typeName+'/'+twoType.typeName+(goods.leiBie?'/'+goods.leiBie:goods.daiHua?'/'+goods.daiHua:'')"></p>
                    <div class="goods-type-1" v-if="goodsType==1">
                        <div class="price">
                            <!--<p class="old-price">参考价：<s>¥999</s></p>-->
                            <p class="new-price">价格：<span class="main-color">¥</span><span class="price-num main-color">{{goods.price}}</span></p>
                        </div>
                        <div class="list-item"><div class="lab">配送</div><div class="lab-txt" v-text="goods.distributionFee>0?'¥'+goods.distributionFee:'快递免运费'"></div></div>
                        <div class="list-item">
                            <div class="lab">数量</div>
                            <div class="lab-txt">
                                <el-input-number v-model="buyNum" @change="handleBuyNumChange" :min="1" :max="goods.stock" :step="1" step-strictly></el-input-number>
                                <span class="kuCun">库存 {{goods.stock}}</span>
                            </div>
                        </div>
                        <div class="list-item"><div class="lab"></div><div class="lab-txt"><el-button  class="btn-price" v-if="goodsType=='1'" @click="goBuy(id,buyNum,goods.stock)"  :disabled="goods.daiIng==1||goods.daiIng==2"><i class="btn-icon el-icon-shopping-cart-2"></i>立即购买</el-button></div></div>
                    </div>
                    <div class="status mb20" v-if="goods.daiIng==1||goods.daiIng==2"><span style="padding-left:20px;line-height: 70px;">正在直播中，请前往APP</span></div>

                    <div v-else>
                        <div class="status mb20" v-if="goodsType!==1&&goods.state!==1"><span style="padding-left:20px;line-height: 70px;">拍卖商品已失效</span></div>
                        <div class="status" :class="{'mb20':goodsType==2}" v-if="goodsType!==1&&goods.state==1">
                            <div class="now-status">正在 <br>拍卖</div>
                            <div class="now-time">
                                <p>距离结束仅剩：<span class="count-time"><timeCounter :endTime="goods.overTime" :nowTime="nowTime" v-if="goods.overTime"></timeCounter></span></p>
                                <p class="num"> 出价 <span class="count-num">{{auctionTotal}}</span> 次</p>
                            </div>
                        </div>
                    </div>

                    <div class="time-data mb20"  v-if="goodsType!==1">
                        <div class="item"><span class="label">当前价</span> <span class="txt price-txt">¥{{goods.price}}</span></div>
                        <div class="item inline-item"><span class="label">起拍价</span> <span class="txt">¥{{goods.startPrice}}</span></div>
                        <div class="item inline-item"><span class="label">加价幅度</span> <span class="txt">¥{{goods.addPrice}}</span></div>
                        <div class="item inline-item"><span class="label">一口价</span> <span class="txt">¥{{goods.onePrice}}</span></div>
                        <el-button  class="btn-price" v-if="goods.state==1" @click="goOffer()" :disabled="goods.daiIng==1||goods.daiIng==2">去出价</el-button>
                    </div>
                    <div class="pai-list" v-if="goodsType!==1">
                        <div class="divider"><span class="cishu">此拍品被出价{{auctionTotal}}次</span> <p class="line"></p> </div>
                        <ul class="pai-item" v-for="(g,i) in auctionTotalList" :key="i">
                            <li>
                                <el-image class="fl img" :src="$common.imgPath(g.user.headImg)" :alt="g.user.nickName" lazy></el-image>
                                <div class="fl">
                                    <p class="name">{{g.user.nickName}}</p>
                                    <p class="time">{{g.user.createTime}}</p>
                                </div>
                            </li>
                            <li>出价:¥{{g.price}}</li>
                            <li class="first" v-if="i==0">领先</li>
                        </ul>
                    </div>
                </div>
            </div>
            <hr style="border:0.5px solid #DAD7D7;" v-if="goodsType==1">
            <div style="overflow: hidden;" v-if="goodsType==1">
                <div class="fl shop">
                    <div class="shop-name">
                        {{shop.shopName}}
                        <el-tag class="shop-tag" color="#15B249" size="mini" effect="dark" v-if="shop.isCelebrity==1">名人</el-tag>
                    </div>
                    <ul class="num-list">
                        <li>
                            <p><span class="num">{{nowGoodsNum}}</span>件</p>
                            <span class="tit">全部拍品</span>
                        </li>
                        <li>
                            <p><span class="num">{{shop.collectNum}}</span>人</p>
                            <span class="tit">粉丝数</span>
                        </li>
                        <li>
                            <p><span class="num">{{shop.starNum}}</span></p>
                            <span class="tit">评分</span>
                        </li>
                    </ul>
                    <div class="btn-shop">
                        <el-button  class="btn fl" @click="$router.push({path:`/shop/detail/${shop.shopId}`})"><i class="el-icon-s-home"></i>进店逛逛</el-button>
                        <el-button class="btn fl" @click="goChat(shop.userId)"><i class="el-icon-chat-line-round"></i>联系客服</el-button>
                        <!--<el-button  class="btn fl" @click="goChat(shop.userId)"><i class="el-icon-s-home"></i>联系客服</el-button>-->
                        <el-button  class="btn fr" @click="setShopFollow()"><span class="icon-collect" :class="isCollect?'collect-yellow-color':'collect-grey-color'"></span><span v-text="isCollect?'取消关注':'关注店铺'"></span></el-button>
                    </div>

                </div>
                <div class="fr goods-desc">
                    <div class="desc-divider"><span class="title">拍品介绍</span> <p class="line"></p> </div>
                    <div class="pai-desc-html">
                        <div class="text-cont">{{goods.goodsDesc}}</div>
                        <el-image :src="$common.imgPath(item)" v-for="item in goodsInfoImgList" :key="item" style="width:100%;" lazy></el-image>
                    </div>
                </div>
            </div>
            <div v-if="goodsType==3" class="desc-divider"><span class="title">拍品介绍</span> <p class="line"></p> </div>
        </div>
        <div v-if="goodsType==3" class="main-bg">
            <div class="main-wrap pai-desc-html">
                <div class="text-cont">{{goods.goodsDesc}}</div>
                <el-image :src="$common.imgPath(item)" v-for="item in goodsInfoImgList" :key="item" style="width:100%;" lazy></el-image>
            </div>
        </div>

        <el-dialog
                title="出价"
                :visible.sync="auctionPriceDialogVisible"
                width="450px"
                >
            <el-input
                    class="inp-txt inp-offer"
                    placeholder="请输入竞拍价格"
                    v-model="offerPrice"
                    :maxlength="6"
                    onkeyup="this.value=this.value.replace(/\D/g,'')"
                    onafterpaste="this.value=this.value.replace(/\D/g,'')"
            >
                <span class="font-600" slot="prefix">¥</span>
            </el-input>
            <ul class="table-row mt20">
                <li>领先价：<span class="cell-red">¥{{goods.price}}</span></li>
                <li>加价幅度：<span class="cell-red">¥{{goods.addPrice}}</span></li>
                <li>起拍价：<span class="cell-red">¥{{goods.startPrice}}</span></li>
            </ul>
            <span slot="footer" class="dialog-footer">
                <el-button @click="auctionPriceDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="addAuctionPrice()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    import PicZoom from 'vue-piczoom'
    import timeCounter from '../../components/timeCounter'
    import {findGoodsInfoById,getAuctionPageForGoods,addAuctionForUser} from '../../api/goods'
    import {setShopFollow,isShopFollow} from '../../api/shop'
    export default {
        data(){
            return {
                nowTime:'',//服务器当前时间
                userInfo:JSON.parse(localStorage.getItem('user'))||null,//登录用户信息
                isCollect:false,//是否关注店铺
                goodsType:0,//商品类型:1普通商品 2视频商品 3竞拍商品 4直播商品
                currentIndex:-1,
                current:1,
                size:20,
                oneType:{
                    typeName:''
                },
                twoType:{
                    typeName:''
                },
                nowGoodsNum:0,
                shop:{
                    collectNum:0,//粉丝数
                    starNum:0//评分

                },
                goods:{
                    goodsName:'',
                    price:0
                },
                buyNum:1,//购买数量
                auctionTotal:0,//出价次数
                auctionTotalList:[],//出价列表
                isShowVideo:false,//是否显示视频
                currentImg:'',//当前显示的图片
                goodsInfoImgList:[],//详情介绍中的图片
                goodsImgList:[],//缩略图片
                auctionInterval:null,
                auctionPriceDialogVisible:false,//出价弹窗开关
                offerPrice:'',//出价价格
            }
        },
        components:{
            timeCounter,
            PicZoom
        },
        computed:{
            id(){
                return this.$route.params.id||0;
            }
        },
        created(){
            if(this.id){
                this.getGoodsInfoById();
            }
        },
        methods:{
            goChat(userId){
                let uesrIdNo = userId.toLowerCase()
                this.$router.push({path:`/session/${uesrIdNo}`})
            },
            goBuy(id,num,stock){
                if(stock===0){
                    this.$message({
                        type: 'info',
                        message: '商品库存数量为0,不可购买'
                    });return false;
                }
                if(num===0){
                    this.$message({
                        type: 'info',
                        message: '购买数量不能为空'
                    });return false;
                }
                this.$router.push({'path':`/goods/order/detail/${id}/${num}`})
            },
            goOffer(){
                if(this.userInfo){
                    this.auctionPriceDialogVisible=true;
                }else {
                    this.$store.commit('changeLoginShow',true);
                }

            },
            addAuctionPrice(){
                if(this.offerPrice==''){
                    this.$message({
                        type: 'info',
                        message: '竞拍价格不能为空'
                    });return false;
                }
                if(this.goods.onePrice>0){
                    if(this.offerPrice>=this.goods.onePrice){
                        this.submitAuction()
                        return;
                    }
                    if(this.auctionTotal==0&&this.offerPrice>=this.goods.price){
                        this.submitAuction()
                        return;
                    }else if(this.auctionTotal!=0&&this.offerPrice>=this.goods.price+this.goods.addPrice){
                        this.submitAuction()
                        return
                    }

                }
                if(this.goods.onePrice==0){
                    if(this.auctionTotal==0&&this.offerPrice>=this.goods.price){
                        this.submitAuction()
                        return;
                    }else if(this.auctionTotal!=0&&this.offerPrice>=this.goods.price+this.goods.addPrice){
                        this.submitAuction()
                        return
                    }
                }
                this.$message({
                    type: 'info',
                    message: '请输入正确的竞拍价格'
                });return false;
            },
            submitAuction(){
                addAuctionForUser({
                    userId:this.userInfo.userId,
                    goodsId:this.id,
                    price:this.offerPrice
                }).then(()=>{
                    this.$message({
                        type: 'info',
                        message: '出价成功'
                    });
                    this.auctionPriceDialogVisible=false;
                    this.getGoodsInfoById();
                });
            },
            handleBuyNumChange(value) {
                console.log(value);
            },
            getGoodsAuction(){
                getAuctionPageForGoods({
                    goodsId:this.id
                }).then(res=>{
                    if(res.data){
                        this.auctionTotal=res.data.total;
                        this.auctionTotalList=res.data.records;
                    }
                })
            },
            getGoodsInfoById(){
                findGoodsInfoById({
                    goodsId:this.id,
                    current:this.current,
                    size:this.size
                }).then(res=>{
                    const {oneType,twoType,nowGoodsNum,isCollect,shop,goods} = res.data;
                    this.nowTime=res.nowTime;
                    this.oneType=oneType;
                    this.twoType=twoType;
                    this.nowGoodsNum=nowGoodsNum;
                    this.isCollect=isCollect;
                    this.shop=shop;
                    this.goods=goods;
                    if(this.goods.goodsVideo){
                        this.isShowVideo=true;
                    }else {
                        this.isShowVideo=false;
                        this.currentIndex=0;
                    }
                    let goodsImgArr=[]
                    let goodsImgInfoArr=[]
                    if(goods.goodsType==1||goods.goodsType==3){
                        goodsImgArr.push(goods.goodsLog);
                        goodsImgInfoArr.push(goods.goodsLog);
                    }
                    if(goods.goodsImg){
                        if(goods.goodsImg.indexOf(',')>0){
                            goodsImgArr.push(...goods.goodsImg.split(','));
                        }else {
                            goodsImgArr.push(goods.goodsImg)
                        }
                    }
                    if(goods.goodsInfoImg){
                        if(goods.goodsInfoImg.indexOf(',')>0){
                            goodsImgInfoArr.push(...goods.goodsInfoImg.split(','));
                        }else {
                            goodsImgInfoArr.push(goods.goodsInfoImg);
                        }
                    }
                    this.currentImg=goodsImgArr[0];
                    this.goodsImgList=goodsImgArr;
                    this.goodsInfoImgList=goodsImgInfoArr;
                    this.goodsType=res.data.goods.goodsType;
                    if(this.goodsType!=1){
                        this.getGoodsAuction();
                        this.auctionInterval = setInterval(()=>{
                            this.getGoodsAuction()
                        },10000);
                    }
                })
            },
            //操作关注/取消 店铺
            setShopFollow(){
                if(this.userInfo){
                    setShopFollow({
                        shopId:this.shop.shopId
                    }).then(res=>{
                        this.isCollect=res.data;
                        //console.log('this.isCollect',this.isCollect);
                    })
                }else {
                    this.$store.commit('changeLoginShow',true);//登录
                }


            },
            prevThumb(){
                if(this.isShowVideo){
                    return;
                }
                if(this.currentIndex==0){
                    if(this.goods.goodsVideo){
                        this.isShowVideo=true;return;
                    }else {
                        return;
                    }
                }else {
                    this.isShowVideo=false;
                }
                this.currentIndex--;
                this.currentImg=this.goodsImgList[this.currentIndex];
            },
            nextThumb(){
                if(this.isShowVideo){
                    this.isShowVideo=false;
                    this.currentIndex=0;
                    this.currentImg=this.goodsImgList[this.currentIndex];
                    return;
                }
                if(this.currentIndex==-1&&this.goods.goodsVideo){
                    this.isShowVideo=true;return;
                }else {
                    this.isShowVideo=false;
                }
                if(this.currentIndex==this.goodsImgList.length-1)return false;
                this.currentIndex++;
                this.currentImg=this.goodsImgList[this.currentIndex];
            },
            currentThumb(index,img){
                this.isShowVideo=false;
                this.currentIndex=index;
                this.currentImg=img;
            }
        },
        destroyed(){
            clearInterval(this.auctionInterval);
            this.auctionInterval=null;
        },
        filters:{

        }
    }
</script>
<style scoped lang="scss">
    @import '../../assets/css/common';
    .crumb{
        padding:15px 0;
    }
    .btn-price{
        .btn-icon{
            margin-right:12px;
            font-size:20px;
        }
        display: block;
        width:222px;
        height:46px;

        background:rgba(21,178,73,1);
        font-size:16px;
        color:#f8f8f8;
    }
    .goods-cont{
        overflow: hidden;
        padding-top:15px;
        /*padding:15px 0 36px;*/
        .goods-img{
            .big-img,.video-main{
                width:350px;
                height:350px;
                background-color:#f8f8f8;
                outline:none;
            }
            .thumb{
                padding:10px 0 15px;
                .btns{
                    line-height:54px;
                    font-size:32px;
                    color:#E3E3E3;
                    font-weight:600;
                    cursor: pointer;
                }
                .thumb-cont{
                    width:283px;
                    height:56px;
                    display: inline-block;
                    position: relative;
                    overflow-x: scroll;
                    .thumb-list{
                        white-space:nowrap;
                        overflow-y: hidden;
                        overflow-x: auto;
                        position: absolute;
                        left: 0;
                        top: 0;
                        bottom: -17px;
                        transition: all .3s;
                        li{
                            cursor: pointer;
                            float: left;
                            width:54px;
                            height:54px;
                            background-color: #f7f6f9;
                            border:1px solid #fff;
                            overflow: hidden;
                            text-align: center;
                            &+li{margin-left:10px;}
                            &.current{
                                border:1px solid $main-color;
                            }
                            .video-option{
                                position: relative;
                                .thumb-img{
                                    position: absolute;
                                    width:100%;
                                    left:0;
                                    top:0;}
                                .btn-play{
                                    display: inline-block;
                                    cursor: pointer;
                                    line-height:30px;
                                    text-align: center;
                                    position: absolute;
                                    top:50%;
                                    left:50%;
                                    margin-top:15px;
                                    margin-left:-15px;
                                    width:30px;
                                    height:30px;
                                    opacity:0.5;
                                    background-color:#000;
                                    color:#fff;
                                    font-size:20px;
                                    -webkit-border-radius: 50%;
                                    -moz-border-radius: 50%;
                                    border-radius: 50%;
                                }
                            }
                            .img-item{width:100%;height: 100%;}
                        }
                    }
                }

            }

        }
        .goods-info{
            padding-left:27px;
            .info-desc{color:#2D2D2D;font-size:18px;line-height:32px;
                font-weight:600;}
            .tag{color:#555555;font-size:14px;line-height:32px;padding-bottom:10px;}
            .goods-type-1{
                .price{
                    width:761px;
                    /*height:66px;*/
                    padding:30px 20px;
                    color:#333333;
                    font-size:16px;
                    background:rgba(246,250,247,1);
                    .old-price{padding-bottom:20px;}
                    .new-price{
                        .price-num{font-size:26px;}
                    }
                }
                .list-item{
                    padding:20px 0;
                    overflow: hidden;
                    display: table;
                    .lab{
                        display: table-cell;
                        font-size:16px;color:#666666;width:80px;}
                    .lab-txt{display: table-cell;
                        font-size:18px;color:#333333;
                    }
                    .kuCun{font-size:16px;color:#666666;padding-left:30px;}
                }

            }
            .status{
                display: table;
                height:70px;
                width:100%;
                background: url("../../assets/images/goods-bg.png")no-repeat center;
                color:#FFFFFF;
                .now-status{
                    display: table-cell;
                    vertical-align: middle;
                    width:60px;
                    /*height:50px;*/
                    text-align: center;
                    /*background-color:#15B249;*/
                    font-size:16px;
                    /*padding:10px 0;*/
                }
                .now-time{
                    display: table-cell;
                    vertical-align: middle;
                    /*background-color:#45bc62;*/
                    /*padding:10px 0 10px 13px;*/
                    padding-left:12px;
                    font-size:17.55px;
                    /*height:50px;*/
                    width: 747px;
                    .num{font-size:12px;padding-top:5px;}
                }
            }
            .time-data{
                border:1px solid #E3E3E3;
                width:820px;

                .inline-item{
                    display: inline-block;
                    &+.inline-item{margin-left:25px;}
                }
                .item{
                    padding:20px 0 0 15px;
                    color:#B9B9B9;
                    .label{font-size:12px;padding-right:16px;}
                    .txt{font-size:16px}
                    .txt.price-txt{font-size:19.26px;color:$main-color;
                        font-weight:600;}
                }
                .btn-price{margin:15px 0 20px 15px;}
            }
            .pai-list{
                height: 405px;
                padding:20px 22px 30px 15px;
                background:rgba(248,248,248,1);
                overflow-y: scroll;
                .divider{
                    position: relative;
                    height:20px;
                    text-align:center;
                    padding-bottom:5px;
                    .cishu{
                        position: absolute;
                        left:20%;
                        top:0;
                        display: block;
                        z-index: 100;
                        background-color:#f8f8f8;
                        padding:0 30px;
                        font-size:18px;
                        color:#5B5B5B;
                    }
                    .line{
                        position: absolute;
                        height:1px;
                        width:100%;
                        top:10px;
                        left:0;
                        background-color:#CECECE;
                        z-index:99;
                    }
                }
                .pai-item{
                    //overflow: hidden;
                    padding-top:19px;
                    color:#0D0D0D;
                    display: table;
                    li{
                        //float: left;
                        display: table-cell;
                        vertical-align: middle;
                        width:200px;
                        text-align: left;
                        &.first{font-size:16px;color:$main-color;font-weight:600;
                        }
                        .img{
                            width:34px;
                            height:34px;
                            margin-right:12px;
                            -webkit-border-radius: 50%;
                            -moz-border-radius: 50%;
                            border-radius: 50%;
                        }
                        .name{
                            font-size:16px;
                        }
                        .time{
                            color:#9D9DA4;
                            font-size:12px;
                        }
                    }

                }
            }

        }

    }
    .shop{
        margin-top:20px;
        border:1px solid #E6E6E6;
        width:348px;
        .shop-name{
            text-align:center;
            font-size:20px;color:#000;
            font-weight:600;
            border-bottom:1px solid #E6E6E6;
            padding:23px 0 24px;
            background-color:#F7F7F7;
            .shop-tag{
                width: 35px;
                height: 17px;
                background: #15b249;
                border-radius: 4px;
                color: #ffffff;
                border: none;
                margin-left: 9px;
                font-size: 13px;
                padding: 0;
                line-height: 17px;
                font-weight: 500;
                vertical-align: middle;
            }
        }
        .num-list{
            color:#222222;
            display: table;
            height:32px;
            width:100%;
            padding-top:30px;
            li{
                display: table-cell;
                vertical-align: middle;
                font-size:20px;
                text-align: center;
                width:33.33%;
                &+li{
                    border-left:1px solid #E0DDDD;
                }
                .num{
                    font-size:20px;
                    font-weight:600;
                }
                .tit{
                    font-size:14px
                }
            }

        }
        .btn-shop{
            padding:39px 20px 28px;
            overflow: hidden;
            .btn{
                i{color:$main-color;font-size:15px;margin-right:5px;}
                width:98px;
                height:40px;
                /*width:145px;
                height:50px;*/
                background:rgba(247,247,247,1);
                border:1px solid rgba(206,206,206,1);
                color:#0D0D0D;
                font-size:14px;
                padding:0;
                -webkit-border-radius: 0;
                -moz-border-radius: 0;
                border-radius: 0;
                &+.btn{margin-left:5px;}
                .icon-collect{
                    display: inline-block;
                    width:15px;
                    height:15px;
                    vertical-align: middle;
                    margin-right:5px;
                }
            }
        }
    }
    .goods-desc{
        width:822px;
        padding-top:20px;
    }
    .desc-divider{
        position: relative;
        width:600px;
        height:30px;
        text-align:center;
        margin:36px auto 39px;
        .title{
            position: absolute;
            left:50%;
            top:0;
            display: block;
            z-index: 200;
            background-color:#ffffff;
            width:200px;
            margin-left:-100px;
            font-size:30px;
            color:$main-color;
            font-weight:600;
        }
        .line{
            position: absolute;
            height:1px;
            width:100%;
            top:15px;
            left:0;
            background-color:#CECECE;
            z-index:99;
        }
    }
    .pai-desc-html{
        background-color:#ffffff;
        padding:20px 44px;
        text-align: center;
        .text-cont{
            text-align: left;
            text-indent: 30px;
            line-height: 24px;
        }
    }

</style>
<style lang="scss">
    .inp-offer{
        /*width:350px;*/
        /*height:45px;*/
        /*padding-left:10px;*/
        line-height:38px;
    }
    .table-row{
        display: table;
        width:100%;
        &>li{
            display: table-cell;
        }
    }
</style>